import { render, staticRenderFns } from "./DepartamentoPessoalContainer.vue?vue&type=template&id=dfe24ca6&scoped=true"
import script from "./DepartamentoPessoalContainer.vue?vue&type=script&lang=js"
export * from "./DepartamentoPessoalContainer.vue?vue&type=script&lang=js"
import style0 from "./DepartamentoPessoalContainer.vue?vue&type=style&index=0&id=dfe24ca6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe24ca6",
  null
  
)

export default component.exports